/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Limit_1_ValueInputs */

const en_svc_rag_limit_1_value = /** @type {(inputs: Svc_Rag_Limit_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When the sources do not answer the question, it says so and hands over.`)
};

const lv_svc_rag_limit_1_value = /** @type {(inputs: Svc_Rag_Limit_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja avotos atbildes nav, sistēma to pasaka un nodod jautājumu cilvēkam.`)
};

/**
* | output |
* | --- |
* | "When the sources do not answer the question, it says so and hands over." |
*
* @param {Svc_Rag_Limit_1_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_limit_1_value = /** @type {((inputs?: Svc_Rag_Limit_1_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Limit_1_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_limit_1_value(inputs)
	return en_svc_rag_limit_1_value(inputs)
});